const theme = {
    colors: {
        primary: [
            "hsl(205,79%,97%)",
            "hsl(205,97%,85%)",
            "hsl(205,84%,74%)",
            "hsl(205,74%,65%)",
            "hsl(205,65%,55%)",
            "hsl(205,67%,45%)",
            "hsl(205,76%,39%)",
            "hsl(205,82%,33%)",
            "hsl(205,87%,29%)",
            "hsl(205,100%,21%)"
        ],
        secondary: [
            "hsl(171,82%, 96%)",
            "hsl(172,97%,88%)",
            "hsl(174,96%,78%)",
            "hsl(176,87%,67%)",
            "hsl(178,78%,57%)",
            "hsl(180,77%,47%)",
            "hsl(182,85%,39%)",
            "hsl(184,90%,34%)",
            "hsl(186,91%,29%)",
            "hsl(188,91%,23%)"
        ],
        grey: [
            "hsl(0,0%,97%)",
            "hsl(125,2%,91%)",
            "hsl(247,2%,81%)",
            "hsl(0,0%,69%)",
            "hsl(0,0%,62%)",
            "hsl(0,0%,49%)",
            "hsl(0,0%,38%)",
            "hsl(0,0%,32%)",
            "hsl(0,0%,21%)",
            "hsl(0,0%,13%)"
        ],
        warning: [
            "hsl(49,100%,97%)",
            "hsl(48,100%,88%)",
            "hsl(48,95%,76%)",
            "hsl(48,94%,68%)",
            "hsl(44,92%,63%)",
            "hsl(42,87%,55%)",
            "hsl(36,77%,49%)",
            "hsl(29,80%,44%)",
            "hsl(22,82%,39%)",
            "hsl(15,86%,30%)"
        ],
        error: [
            "hsl(360,100%,98%)",
            "hsl(360,82%,89%)",
            "hsl(360,77%,78%)",
            "hsl(360,71%,66%)",
            "hsl(360,64%,55%)",
            "hsl(360,67%,44%)",
            "hsl(360,72%,38%)",
            "hsl(360,79%,32%)",
            "hsl(360,85%,25%)",
            "hsl(360,92%,20%)"
        ],
        success: [
            "hsl(122, 60%, 97%)",
            "hsl(122, 60%, 86%)",
            "hsl(122, 55%, 74%)",
            "hsl(122, 49%, 61%)",
            "hsl(122, 40%, 52%)",
            "hsl(122, 39%, 42%)",
            "hsl(122, 39%, 34%)",
            "hsl(122, 39%, 27%)",
            "hsl(122, 39%, 21%)",
            "hsl(122, 39%, 14%)"
        ]
    },
    fontSize: [16, 18, 20, 24, 30, 36, 48, 60, 72, 10, 12, 14],
    fontFamily: {
        Lato: "Lato",
        Merriweather: "Merriweather"
    },
    fontNative: {
        lato300: "lato300",
        lato400: "lato400",
        lato700: "lato700",
        lato900: "lato900",
        merriweather300: "merriweather300",
        merriweather400: "merriweather400",
        merriweather700: "merriweather700",
        merriweather900: "merriweather900"
    },
    fontWeight: {
        light: 300,
        normal: 400,
        bold: 700,
        heavy: 900,
        inherit: "inherit"
    },
    space: [4, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 640, 768],
    radius: {
        light: "3px",
        normal: "4px",
        strong: "10px",
        round: "50%"
    },
    shadow: {
        "1": "0 1px 3px rgba(0, 0, 0, 0.15)",
        "2": "0 2px 6px rgba(0, 0, 0, 0.15)",
        "3": "0 5px 15px rgba(0, 0, 0, 0.15)",
        "4": "0 10px 24px rgba(0, 0, 0, 0.15)",
        "5": "0 15px 35px rgba(0, 0, 0, 0.15)",
        card1: "0px 1px 1px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0,0,0,0.1)",
        card2: "0 1px 4px rgba(0,0,0,0.12), 0 2px 6px rgba(0, 0, 0, 0.09)",
        card3: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
        card4: "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
        card5: "0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)"
    },
    shadowNative: [
        // 0
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 1
            },
            shadowOpacity: 0.18,
            shadowRadius: 1.0,
            elevation: 1
        },
        // 1
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 1
            },
            shadowOpacity: 0.2,
            shadowRadius: 1.41,
            elevation: 2
        },
        // 3
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 1
            },
            shadowOpacity: 0.22,
            shadowRadius: 2.22,
            elevation: 3
        },
        // 4
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 2
            },
            shadowOpacity: 0.23,
            shadowRadius: 2.62,
            elevation: 4
        },
        // 5
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 2
            },
            shadowOpacity: 0.25,
            shadowRadius: 3.84,
            elevation: 5
        },
        // 6,
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 3
            },
            shadowOpacity: 0.27,
            shadowRadius: 4.65,
            elevation: 6
        },
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 3
            },
            shadowOpacity: 0.29,
            shadowRadius: 4.65,
            elevation: 7
        },
        // 8
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 4
            },
            shadowOpacity: 0.3,
            shadowRadius: 4.65,
            elevation: 8
        },
        // 9
        {
            shadowColor: "#000",
            shadowOffset: {
                width: 0,
                height: 4
            },
            shadowOpacity: 0.32,
            shadowRadius: 5.46,
            elevation: 9
        }
    ],
    speed: {
        immediate: "0.1s",
        fast: "0.15s",
        normal: "0.2s",
        slow: "0.3s",
        slower: "0.5s",
        long: "1s"
    },
    lineHeight: {
        condensed: 1.0,
        normal: 1.15,
        heading: 1.3,
        spaced: 1.5,
        wide: 1.8
    }
};
export const colorKeys = Object.keys(theme.colors);
export default theme;
//# sourceMappingURL=theme.js.map